var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvent24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 4.00123L19.9998 4.00131C21.0998 4.0014 21.9998 4.90148 21.9997 6.00148L21.9985 20.0015C21.9984 21.1015 21.0984 22.0014 19.9984 22.0013L5.99836 22.0002C4.88836 22.0001 3.99843 21.1 3.99852 20L4.00967 6C4.00976 4.9 4.88984 4.00007 5.99984 4.00016L6.99984 4.00025L7 2.00025L9 2.00041L8.99984 4.00041L16.9998 4.00107L17 2.00107L19 2.00123L18.9998 4.00123ZM5.99934 10.0002L5.99852 20.0002L19.9985 20.0013L19.9993 10.0013L5.99934 10.0002ZM19.9995 8.00131L5.99951 8.00016L5.99967 6.00016L19.9997 6.00131L19.9995 8.00131ZM17.9991 13.0011L12.9991 13.0007L12.9987 18.0007L17.9987 18.0011L17.9991 13.0011Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent24Px);
export default __webpack_public_path__ + "static/media/event_24px.9cdc13d33dbfea1c3e2ff823f44d9736.svg";
export { ForwardRef as ReactComponent };